/** All available dashboard widgets types */
export enum DashboardWidgetTypeEnum {
  /** "Accounts money" widget */
  ACCOUNTS_MONEY = 'ACCOUNTS_MONEY', // Деньги на счетах
  /** "Cash money" widget */
  CASHES_MONEY = 'CASHES_MONEY', // Деньги в кассе
  /** "Accounts receivable" widget */
  ACCOUNTS_RECEIVABLE = 'ACCOUNTS_RECEIVABLE', // Дебиторская задолженность
  /** "Accounts payable" widget */
  ACCOUNTS_PAYABLE = 'ACCOUNTS_PAYABLE', // Кредиторская задолженность
  /** "Unallocated documents" widget */
  UNALLOCATED_DOCUMENTS = 'UNALLOCATED_DOCUMENTS', // Нераспределенные документы
  /** "Debtors" widget */
  DEBTORS = 'DEBTORS', // Должники
  /** "Profit and Loss" widget */
  PROFIT_AND_LOSS = 'PROFIT_AND_LOSS', // Доходы и расходы
  /** "Budget per direction" widget */
  BUDGET_PER_DIRECTION = 'BUDGET_PER_DIRECTION', // Бюджет по статьям
  /**
   * "Event calendar" widget
   */
  EVENT_CALENDAR = 'EVENT_CALENDAR', // Календарь событий
  /** "VAT accounts" widget */
  VAT = 'VAT', // НДС
  /** "Pending projects" widget */
  PROJECT_ACTIONS = 'PROJECT_ACTIONS', // Задачи, ожидающие действия от пользователей
  // /** "Report with saved filter: Payments - Payment Approval" widget */
  // SAVED_FILTER_FINANCE_BRS_DDS = 'SAVED_FILTER_FINANCE_BRS_DDS', // Сохраненный отчет: Платежи - Согласование платежей
  /** "Report with saved filter: Plan-Fact - Profit And Loss Statement" widget */
  SAVED_FILTER_FINANCE_PLAN_FACT_BALANCE = 'SAVED_FILTER_FINANCE_PLAN_FACT_BALANCE', // Сохраненный отчет: Бюджетирование - ОПиУ
  // /** "Report with saved filter: Plan-Fact - Profit And Loss Analysis" widget */
  // SAVED_FILTER_FINANCE_PLAN_FACT_PAYMENT_OUTGOING = 'SAVED_FILTER_FINANCE_PLAN_FACT_PAYMENT_OUTGOING', // Сохраненный отчет: Плат-факт - Анализ расходов и доходов
  /** "Report with saved filter: Documents - Registry - Profit And Loss Analysis" widget */
  SAVED_FILTER_FINANCE_DOCUMENT_REGISTRY = 'SAVED_FILTER_FINANCE_DOCUMENT_REGISTRY', // Сохраненный отчет: Документы - Реестр
  HELPDESK_NEW_TASKS = 'HELPDESK_NEW_TASKS', // HelpDesk: Новые заявки
  HELPDESK_OPENED_TASKS = 'HELPDESK_OPENED_TASKS', // HelpDesk: Открытые заявки
  HELPDESK_STATS = 'HELPDESK_STATS', // HelpDesk: Статистика
  ACCOUNTS_RECEIVABLE_DYNAMICS = 'ACCOUNTS_RECEIVABLE_DYNAMICS', // Динамика дебиторской задолженности
  ACCOUNTS_PAYABLE_DYNAMICS = 'ACCOUNTS_PAYABLE_DYNAMICS', // Динамика кредиторской задолженности
  CASH_FLOW_ANALYSIS = 'CASH_FLOW_ANALYSIS', // Анализ движения ДС
  HELPDESK_LAST_TASKS = 'HELPDESK_LAST_TASKS', // Заявки HD
  OVERSPENDING = 'OVERSPENDING', // Перерасход
  ABC_ANALYSIS = 'ABC_ANALYSIS',
  BRS_TASKS = 'BRS_TASKS', // Платежи
  /** Пропуска. "Открыть дверь" */
  OPEN_DOOR = 'OPEN_DOOR',
  BALANCE_SHEET = 'BALANCE_SHEET',
  CCTV_TRANSIT_TASKS = 'CCTV_TRANSIT_TASKS',
  CCTV_RESIDENT_CARS = 'CCTV_RESIDENT_CARS',
}
